export const reserve = {
	title: "Reserva y Lista de Espera",
	tabs: {
		reserveManager: "Gestión de Reservas",
		queueManager: "Gestión Lista de Espera",
		generalReserveConfig: "Configuración General",
		calendarManagement: "Gestión de Calendario",
		subTabs: {
			reserveConfig: "Configuración General de Reserva",
			reserveDaysConfig: "Configuración de los días de Reserva",
			queueConfig: "Configuración Lista de Espera",
			siteConfig: "Configuración del Sitio",
		},
	},
	cardReserve: {
		contact: "Contacto",
		phone: "Celular",
		email: "E-mail",
		tableTo: "Mesa para",
		people: "personas",
		actionButtons: {
			accommodate: "Acomodar",
			cancel: "Cancelar",
			noShow: "No-show",
		},
		note: "Observación",
	},
	statusDescription: {
		accommodated: "Acomodado",
		canceled: "Cancelado",
		"no-show": "No-show",
		reserved: "Reservado",
	},
	collapseShiftList: {
		successNotification: "Sus cambios han sido guardados.",
		labels: {
			reserved: "Reservas",
			people: "Personas",
			noShow: "No-show",
			canceled: "Canceladas",
		},
		dialogsConfirmation: {
			cancel: {
				title: "Cancelar",
				subtitle:
					"¿Desea cancelar la reserva? Después de la confirmación esta acción no podrá deshacerse.",
				actionText: "Cancelar reserva",
			},
			noShow: {
				title: "No-show",
				subtitle:
					"¿Desea hacer el cobro de la tasa de no-show? Después de la confirmación esta acción no podrá deshacerse.",
				actionText: "Hacer cobro de no-show",
			},
			seatDown: {
				title: "Acomodar",
				subtitle:
					"¿Desea acomodar al cliente? Después de la confirmación esta acción no podrá deshacerse.",
				actionText: "Confirmar acomodación",
			},
		},
	},
	tableReserveField: {
		tableFor: "Mesas para",
		people: "Personas",
		minOfPeople: "Mínimo de personas",
		deleteConfirmation: {
			title: "Eliminar mesas",
			subtitle:
				"Las mesas serán eliminadas permanentemente. ¿Desea continuar de todos modos?",
			actionText: "Eliminar mesas",
		},
	},
	config: {
		selectFee: {
			person: "Por persona",
			table: "Por mesa",
		},
		selectTime: {
			minutes: "Minutos",
			hours: "Horas",
			days: "Días",
		},
		shiftSelect: {
			to: "a las",
		},
		bookingDays: {
			addTables: "Agregar mesas",
		},
		seatArea: {
			title: "Ambiente",
			name: "Nombre del ambiente",
			noShowFee: "Tasa de no-show",
			noShowTooltip: "Valor a ser cobrado de reservas que no se presentaron.",
			advancedFee: "Cobro anticipado",
			advancedTooltip: "Valor será cobrado durante la reserva.",
			description: "Breve descripción (hasta 45 caracteres)",
			delete: "Eliminar ambiente",
			selectSeatArea: "Seleccione los ambientes y defina las mesas",
		},
	},
	placeConfig: {
		title: "Información del establecimiento",
		postalCode: "Código Postal",
		street: "Dirección",
		streetPlaceholder: "Nombre de la calle o avenida",
		neighborhood: "Colonia",
		state: "Estado",
		statePlaceholder: "Estado",
		city: "Ciudad",
		number: "Número",
		complement: "Complemento (opcional)",
		complementPlaceholder: "Complemento de la dirección",
		phone: "Teléfono",
		businessHours: "Horario de funcionamiento",
		businessHoursPlaceholder: "Ej: De lunes a jueves de 17h a 22h",
	},
	bookingForm: {
		bookableTime: "Horario reservable",
		startTime: "Inicio",
		to: "hasta",
		endTime: "Fin",
		confirmDelete: {
			title: "Eliminar horario",
			subtitle:
				"Este horario reservable será eliminado permanentemente. ¿Desea continuar de todos modos?",
			actionText: "Eliminar horario",
		},
		addTime: "Nuevo horario reservable",
		deleteTime: "Eliminar horario",
		submit: "Guardar cambios",
	},
	siteConfig: {
		title: "Personalización",
		description:
			"Puede subir imágenes de hasta 500kb en los formatos .png, .jpg o .jpeg de acuerdo con las dimensiones mencionadas abajo:",
		brandImage: "Imagen de la marca",
		brandImageObs: "Imagen cuadrada o 500x500 píxeles",
		coverImage: "Imagen de portada",
		galleryImage: "Imagen para galería (opcional)",
		horizontalImageObs: "Imagen horizontal o 1280x780 píxeles",
	},
	reserveConfigPage: {
		reserveConfig: "Configuración General de Reserva",
		reserveConfigDescrip:
			"Configure el horario de funcionamiento, intervalo entre las reservas, tiempo límite de reserva, tolerancia, cancelación y agregue sus ambientes.",
		configCards: {
			businessHours: {
				title: "Horario de funcionamiento",
				description:
					"Defina el horario de funcionamiento de su establecimiento. Los horarios de las reservas respetarán el horario de funcionamiento.",
			},
			toleranceTime: {
				title: "Límite de tolerancia",
				description:
					"¿Hasta cuánto tiempo se esperará la llegada de la persona después del horario de la reserva? ",
			},
			cancelationTime: {
				title: "Cancelación",
				description:
					"¿Cuál es el límite de tiempo para que el cliente solicite la cancelación de la reserva?",
			},
			timeBetweenReservation: {
				title: "Intervalo entre las reservas",
				description: "¿Cuál será el tiempo del intervalo entre una reserva y otra?",
			},
			minimumAdvanceTime: {
				title: "Tiempo límite para reservar",
				description: "¿Hasta cuánto tiempo antes del horario se podrá hacer la reserva? ",
			},
		},
		intervals: {
			morning: "Mañana",
			afternoon: "Tarde",
			night: "Noche",
		},
		seatAreaConfig: "Configuración de ambientes",
		seatAreaConfigDescrip:
			"Agregue, describa y defina las tasas de los ambientes de su establecimiento.",
		confirmationModal: {
			title: "Eliminar ambiente",
			subtitle:
				"Este ambiente será eliminado permanentemente. ¿Desea continuar de todos modos?",
			actionText: "Eliminar ambiente",
		},
		cancelModal: {
			title: "Descartar cambios",
			subtitle:
				"Sus cambios serán eliminados permanentemente. ¿Desea continuar de todos modos?",
			actionText: "Descartar cambios",
		},
		addSeatArea: "Nuevo ambiente",
		requiredFields: "Campos con llenado obligatorio",
		cancel: "Cancelar",
		cancelSucess: "Sus cambios fueron descartados.",
		save: "Guardar cambios",
		sucess: "Sus cambios fueron guardados.",
		error: "Sus cambios no fueron guardados, intente nuevamente.",
	},
	generalConfig: {
		config: "Configuración general",
		makeAdjustments:
			"Haga los ajustes y configuración de horarios e información para compartir en el enlace de reservas.",
	},
	shiftDefinition: {
		setShift: "Definición de turnos",
		configureShift:
			"Configure los turnos de su establecimiento. Los asignará a días de la semana en la configuración de calendario.",
		addShift: "Agregar turno",
	},
	intervalReservation: {
		interval: "Intervalo entre reservas",
		setInterval:
			"Defina los intervalos de tiempo para hacer una reserva, límites de retraso y período de programación.",
		availableReservation: "Disponibilidad para reserva",
		reservationWindow: "Ventana de intervalo en el calendario",
		limit: "Tiempo límite para retraso",
		limitInfo:
			"El límite de retraso no genera cancelación automática, solo la señalización en la lista de reservas.",
	},
	storeDescriptionSession: {
		storeDescription: "Descripción de la tienda",
		describeStore:
			"Describa su tienda para compartir la información en su sitio de reservas.",
		productLink: "Enlace del producto",
		acceptTerms:
			"Acepto compartir la información de esta página con los clientes que visualicen el sitio de reserva.",
		dayAndTime: "Días y horarios de funcionamiento",
		addDayAndTime: "Agregar días y horarios",
		rules: "Reglas y condiciones",
		rulesPlaceholder:
			"Describa aquí las reglas, condiciones y orientaciones de su política de reserva y cancelación.",
		additionalInfo: "Información adicional",
		infoPlaceholdeR: "Si lo desea, describa más información sobre su establecimiento.",
		shareMenuReservation: "¿Compartir enlace para el menú en el sitio de reservas?",
	},
	saveSettings: "Guardar configuración",
	saveChanges: "Guardar cambios",
	deleteShift: "Eliminar turno",
	shiftName: "Nombre del turno",
	shiftNameExemple: "Ej: Mañana, almuerzo, nocturno, etc...",
	start: "Inicio",
	end: "Final",
	daysOfTheWeek: "Días de la semana",
	selectAvailableDays:
		"Es necesario seleccionar los días en que este turno estará disponible para reserva.",
	calendarManagementDescription:
		"Defina la cantidad de lugares que dispone para cada uno de sus turnos. Edite siempre que necesite.",
	createReservation: "Crear reserva",
	modalConfigurations: {
		exclude: {
			title: "¿Está seguro que desea eliminar?",
			text: "Al eliminar estos lugares, perderá las definiciones hechas previamente.",
			confirmButton: "Sí, quiero eliminar",
		},
		discard: {
			title: "¿Quiere descartar los cambios?",
			text: "Al salir sin guardar, no mantendrá los cambios hechos ahora.",
			confirmButton: "Sí, quiero descartar",
		},
		cancel: {
			title: "Cancelar reserva",
			text:
				"¿Está seguro que desea cancelar esta reserva? La eliminación será permanente. Recuerde contactar al cliente para informar la cancelación.",
			confirmButton: "Sí, cancelar reserva",
		},
		accommodate: {
			title: "Acomodar",
			text:
				"¿Las personas de esta mesa ya llegaron? Confirme si está todo correcto para acomodar esta reserva. Esta acción no podrá deshacerse.",
			confirmButton: "Sí, acomodar",
		},
	},
	availableSeatsAmount: "Cantidad de lugares disponibles",
	addMoreSeats: "Agregar más lugares",
	selectShift: "Selección de turno",
	tables: "Mesas",
	seats: "Lugares",
	replicateForAllWeek: "Replicar para todos los días de la semana.",
	editOrDeleteLater:
		"Puede eliminar/editar de cada uno de los días después, si lo prefiere.",
};
